import React, { useState } from 'react';
import { Upload, FileJson, Layers } from 'lucide-react';
import { useLanguage } from '../../../features/language/useLanguage';

interface Props {
    onFilesPicked: (files: File[]) => void;
    disabled: boolean;
}

/** Where a batch starts. Accepts one file or a whole morning's exports. */
export const ArtisanDropzone: React.FC<Props> = ({ onFilesPicked, disabled }) => {
    const { t } = useLanguage();
    const [isDragging, setIsDragging] = useState(false);

    return (
        <div
            className={`border-2 border-dashed rounded-xl p-8 sm:p-16 text-center transition-colors ${isDragging ? 'border-primary-500 bg-primary-50' : 'border-gray-300 hover:border-gray-400 bg-white'
                }`}
            onDragOver={(e) => {
                e.preventDefault();
                setIsDragging(true);
            }}
            onDragLeave={() => setIsDragging(false)}
            onDrop={(e) => {
                e.preventDefault();
                setIsDragging(false);
                if (!disabled) onFilesPicked(Array.from(e.dataTransfer.files));
            }}
        >
            <Upload className="mx-auto h-12 w-12 text-gray-400 mb-4" />
            <p className="text-lg font-medium text-gray-700 mb-1">{t('artisanSync.upload.dropHere')}</p>
            <p className="text-sm text-gray-500 mb-1">{t('artisanSync.upload.supportedFormats')}</p>
            {/* The batch flow has no separate entry point, so the dropzone has to name it. */}
            <p className="text-sm text-gray-500 mb-2 inline-flex items-center gap-1.5">
                <Layers className="h-4 w-4 text-gray-400" />
                {t('artisanSync.upload.bulkHint')}
            </p>
            <br />
            <label className={`text-sm inline-flex items-center gap-2 p-1.5 bg-primary-600 text-white font-medium rounded-lg shadow-sm transition-colors ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-primary-700 cursor-pointer'
                }`}>
                <FileJson className="h-5 w-5" />
                {t('artisanSync.upload.browseFiles')}
                <input
                    type="file"
                    accept=".json,.alog"
                    multiple
                    disabled={disabled}
                    className="hidden"
                    onChange={(e) => {
                        onFilesPicked(Array.from(e.target.files ?? []));
                        e.target.value = '';
                    }}
                />
            </label>
        </div>
    );
};
